import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import { CreditReturnItem } from "../../types/traceability";
import { kgFmt, lbsFmt, pcsFmt } from "../../shared/formatting";

interface CreditReturnItemsTableProps {
  items: CreditReturnItem[];
}

const dollarFmt = (v: number | null | undefined): string =>
  v == null ? "—" : `$${Number(v).toFixed(2)}`;

export default function CreditReturnItemsTable({
  items,
}: CreditReturnItemsTableProps) {
  return (
    <DataTable
      value={items}
      dataKey="id"
      responsiveLayout="scroll"
      size="small"
      className="p-datatable-sm"
      emptyMessage="No items found"
    >
      <Column
        header="Product Name"
        body={(r: CreditReturnItem) => r.product_name ?? "—"}
        style={{ minWidth: 180 }}
      />
      <Column
        header="Lot Number"
        body={(r: CreditReturnItem) => r.lot_number ?? "—"}
        style={{ minWidth: 140 }}
      />
      <Column
        header="PLU"
        body={(r: CreditReturnItem) => r.plu ?? "—"}
        style={{ minWidth: 80 }}
      />
      <Column
        header="Weight (kg)"
        body={(r: CreditReturnItem) => kgFmt(r.weight_in_kg)}
        style={{ minWidth: 120 }}
      />
      <Column
        header="Weight (lbs)"
        body={(r: CreditReturnItem) => lbsFmt(r.weight_in_lbs)}
        style={{ minWidth: 120 }}
      />
      <Column
        header="Pieces"
        body={(r: CreditReturnItem) => pcsFmt(r.piece_count)}
        style={{ minWidth: 100 }}
      />
      <Column
        header="Warehouse / Location"
        body={(r: CreditReturnItem) =>
          r.warehouse_name
            ? `${r.warehouse_name}${r.warehouse_location_name ? ` — ${r.warehouse_location_name}` : ""}`
            : "—"
        }
        style={{ minWidth: 180 }}
      />
      <Column
        header="Unit Cost"
        body={(r: CreditReturnItem) => dollarFmt(r.unit_cost)}
        style={{ minWidth: 110 }}
      />
      <Column
        header="Total Cost"
        body={(r: CreditReturnItem) => dollarFmt(r.total_cost)}
        style={{ minWidth: 110 }}
      />
    </DataTable>
  );
}
